<template>
  <div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
      header-row-class-name="thead-light table-th-colorpd"
    >
      <el-table-column prop="skuCode" label="SKU Code" min-width="100px">
      </el-table-column>
      <el-table-column prop="attribute" label="Attribute" min-width="150px">
        <template slot-scope="row">
          <el-tag class="text-gray rounded-full" type="success">Abcd</el-tag>
        </template>
      </el-table-column>

      <el-table-column prop="variation" label="Variation" min-width="150px">
        <template slot-scope="row">
          <el-tag class="text-gray rounded-full" type="success">Abcd</el-tag>
        </template>
      </el-table-column>

      <el-table-column prop="stockEditable" label="Stock" min-width="120px">
        <template slot-scope="row">
          <div class="mt-6">
            <el-select
              v-model="stockSelect"
              placeholder="Select"
              class="w-full"
            >
              <el-option
                v-for="item in StockSelectOption"
                :key="item.stockSelect"
                :label="item.stockSelect"
                :value="item.stockSelect"
              >
              </el-option>
            </el-select>
            <p class="text-lg font-normal text-success mt-1">In-Stock</p>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="mt-6 flex justify-between bg-f4f5f6 py-4 px-6">
      <h4 class="fsize14 font-semibold">Total Price</h4>

      <h4 class="fsize14 font-medium">2,000</h4>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [
        {
          Ids: "01",
          attribute: "2",
          variation: "₹2000",
          skuCode: "3454347",
        },
      ],
      StockSelectOption: [
        {
          value: "In-Stock",
          label: "In-Stock",
        },
        {
          value: "Out-Stock",
          label: "Out-Stock",
        },
      ],
    };
  },
};
</script>
